import './manageDicts.scss'
import Navbar from "../../../../components/shared/navbar/navbar";
import ManageDictEdition from "./manageDictEdition";
import FormField from "../../../../components/formField/formField";
import { Option } from "../../../../components/shared/navbar/types/navbarProps";
import { FormFieldProps } from "../../../../components/formField/types/formFieldProps";
import { styleFormFieldOnFour } from "../../../../components/shared/stylization";
import { apiContext } from "../../../../contexts/apiContext";
import { ReactComponent as Edit } from "../../../../icons/edit.svg";
import { ReactComponent as Search } from "../../../../icons/search.svg";
import { ManageDictEditionProps, ManageDictsViews } from "./types/manageDictsProps";
import { useContext, useEffect, useState } from "react";

const ManageDicts = () => {
    const api = useContext(apiContext);
    const [currentView, setCurrentView] = useState<ManageDictsViews>(ManageDictsViews.DictList);
    const [search, setSearch] = useState<string>();
    const [dicts, setDicts] = useState<Option[]>([]);
    const [foundOptions, setFoundOptions] = useState<Option[]>(dicts);   
    const [selectedDict, setSelectedDict] = useState<any>({}); 
    
    // Dict list
    useEffect(() => {
        prepareDictList();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const prepareDictList = () => {
        var dictDefinitions = api.featureServices.dictionariesForEditing.sort((a, b) => a[0].localeCompare(b[0]));
        var dictOptions: Option[] = [];

        dictDefinitions.forEach(item => {
            var dictOption: Option = { name: item[0], additionalIcon: Edit, iconAtTheEnd: true, onClick: () => onClickOption(item)};
            dictOptions.push(dictOption);
        })
        setDicts(dictOptions);
        setFoundOptions(dictOptions);
    }

    const onClickOption = (selectedDict: any) => {
        setCurrentView(ManageDictsViews.EditDict);
        setSelectedDict(selectedDict);
    }

    // Search input
    const onChangeInput = (event: string) => {
        setSearch(event);
        var currentOptions = dicts.filter(item => item.name?.toLowerCase().includes(event));
        setFoundOptions(currentOptions);
    }
    
    const searchInputProps: FormFieldProps = {
            inputPlaceholder: "Szukaj",
            value: search,
            style: styleFormFieldOnFour,
            className: "searchDictsInput",
            type: "text",
            additionalIcon: Search,
            pristine: true,
            keepPristine: true,
            pristineIcon: true,
            setValue: onChangeInput
    }
    
    // Edit view
    const onEditClose = () => {
        setCurrentView(ManageDictsViews.DictList);
        setSearch(undefined);
        setFoundOptions(dicts);
    }

    var manageDictEditionProps: ManageDictEditionProps = {
        dictDefinition: selectedDict,
        onClose: onEditClose
    }

    const renderView = () => {
        switch (currentView) {
            case ManageDictsViews.DictList:
                return (
                    <>
                        <div className="searchDictsWrapper">
                            <FormField {...searchInputProps} />
                        </div>
                        <div>
                            <Navbar options={foundOptions} className="manageDictList" ></Navbar>
                        </div>
                    </>
                )
            case ManageDictsViews.EditDict:
                return (
                    <>
                        <ManageDictEdition {...manageDictEditionProps}/>
                    </>
                )
        }
    }
     
    return (
        <>
            {renderView()}
        </>
    );
}

export default ManageDicts;